/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: { inverse: { type: 'variant', values: [ true ] } },
  rules: [
    {
      if: { inverse: true },
      tokens: { backgroundColor: '#ffffff', color: '#000000' }
    }
  ],
  tokens: {
    arrowBorderRadius: 0,
    arrowOffset: 4,
    arrowWidth: 8,
    backgroundColor: '#595959',
    borderRadius: 4,
    color: '#ffffff',
    fontName: 'StagSans',
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 1.4,
    maxWidth: 288,
    minWidth: 0,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 8,
    shadow: {
      blur: 0,
      color: 'rgba(0, 0, 0, 0)',
      inset: false,
      offsetX: 0,
      offsetY: 0,
      spread: 0
    }
  }
}
export default theme
